(() => {
  function init(root) {
    if (root.dataset.nv7Ready) return;
    root.dataset.nv7Ready = 'true';
    const slides = [...root.querySelectorAll('[data-nv7-slide]')];
    const thumbs = [...root.querySelectorAll('[data-nv7-thumb]')];
    function showSlide(index) {
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === index)));
      const counter = root.querySelector('[data-nv7-count]');
      if (counter) counter.textContent = String(index + 1);
    }
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => showSlide(index));
      thumb.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const next = (index + (event.key === 'ArrowRight' ? 1 : -1) + thumbs.length) % thumbs.length;
        showSlide(next); thumbs[next].focus();
      });
    });
    let swipeX = null;
    let swipeY = null;
    const stage = root.querySelector('.nv7-gallery-stage');
    stage?.addEventListener('touchstart', e => { swipeX = e.changedTouches[0].clientX; swipeY = e.changedTouches[0].clientY; }, { passive: true });
    stage?.addEventListener('touchend', e => {
      if (swipeX === null) return;
      const distance = e.changedTouches[0].clientX - swipeX;
      const vertical = e.changedTouches[0].clientY - swipeY;
      if (Math.abs(distance) > 45 && Math.abs(distance) > Math.abs(vertical)) {
        const current = slides.findIndex(s => !s.hidden);
        showSlide((current + (distance > 0 ? -1 : 1) + slides.length) % slides.length);
      }
      swipeX = null; swipeY = null;
    }, { passive: true });
    const packInputs = [...root.querySelectorAll('[data-nv7-offers] input[type="radio"]')];
    const commerceEnabled = document.body.dataset.commerceEnabled === 'true';
    function selectPack(input, updateAddress = false) {
      if (!input) return;
      root.querySelectorAll('[data-nv7-offers]').forEach(offers => {
        offers.querySelectorAll('[data-nv7-pack] input').forEach(other => {
          other.checked = other.value === input.value;
          other.closest('[data-nv7-pack]').classList.toggle('is-selected', other.checked);
        });
        offers.querySelectorAll('[data-nv7-price]').forEach(price => { price.textContent = input.dataset.price; });
        const submit = offers.querySelector('button[type="submit"]');
        if (submit) {
          const available = input.dataset.available === 'true';
          submit.disabled = !commerceEnabled || !available;
          const label = submit.querySelector('[data-nv7-button-label]');
          if (label) label.textContent = !commerceEnabled ? submit.dataset.comingSoonLabel : available ? submit.dataset.addLabel : submit.dataset.soldOutLabel;
        }
      });
      if (updateAddress) {
        const address = new URL(window.location.href);
        address.searchParams.set('variant', input.value);
        window.history.replaceState({}, '', address);
      }
    }
    packInputs.forEach(input => input.addEventListener('change', () => selectPack(input, true)));
    const requestedVariant = new URL(window.location.href).searchParams.get('variant');
    const requestedInput = packInputs.find(input => input.value === requestedVariant);
    if (requestedInput) {
      selectPack(requestedInput);
      requestedInput.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      selectPack(packInputs.find(input => input.checked));
    }
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const connection = navigator.connection;
    const videos = [...root.querySelectorAll('video')];
    const motionVideos = videos.filter(video => video.closest('[data-nv9-motion]'));
    const mediaVisibility = new Map();
    const autoMotionAllowed = () => !reducedMotion.matches && !connection?.saveData && !document.hidden;
    const playQuietly = video => {
      video.muted = true;
      const attempt = video.play();
      if (attempt?.catch) attempt.catch(() => {});
    };
    root.querySelectorAll('[data-nv7-video-toggle]').forEach(button => {
      const wrap = button.matches('.nv7-mini-video') ? button : button.parentElement;
      const video = wrap.querySelector('video');
      if (!video) return;
      const isMotion = wrap.matches('[data-nv9-motion]');
      const playLabel = isMotion ? root.dataset.motionPlayLabel : root.dataset.playLabel;
      const pauseLabel = isMotion ? root.dataset.motionPauseLabel : root.dataset.pauseLabel;
      button.addEventListener('click', () => {
        if (video.paused) {
          videos.forEach(other => {
            if (other !== video) {
              other.pause();
              if (other.closest('[data-nv9-motion]')) other.dataset.userPaused = 'true';
            }
          });
          video.dataset.userPaused = 'false';
          video.dataset.userRequested = 'true';
          playQuietly(video);
        } else {
          video.dataset.userPaused = 'true';
          video.dataset.userRequested = 'false';
          video.pause();
        }
      });
      const sync = () => {
        const playing = !video.paused && !video.ended;
        wrap.classList.toggle('is-playing', playing);
        button.setAttribute('aria-label', playing ? pauseLabel : playLabel);
        button.setAttribute('aria-pressed', String(playing));
        const icon = button.querySelector('.nv7-play');
        if (icon) icon.textContent = playing ? 'Ⅱ' : '▶';
        const label = button.querySelector('[data-nv9-control-text]');
        if (label) label.textContent = playing ? pauseLabel : playLabel;
      };
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('ended', sync);
      sync();
    });
    const updateMotion = () => {
      motionVideos.forEach(video => {
        video.loop = !reducedMotion.matches && !connection?.saveData;
        if (!mediaVisibility.get(video) || document.hidden) video.pause();
        else if (autoMotionAllowed() && video.dataset.userPaused !== 'true') playQuietly(video);
        else if (!autoMotionAllowed() && video.dataset.userRequested !== 'true') video.pause();
      });
    };
    let mediaObserver;
    if ('IntersectionObserver' in window) {
      mediaObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const visible = entry.isIntersecting && entry.intersectionRatio >= 0.2;
          mediaVisibility.set(entry.target, visible);
          if (!visible) entry.target.pause();
        });
        updateMotion();
      }, { threshold: [0, 0.2, 0.5] });
      videos.forEach(video => mediaObserver.observe(video));
    }
    const pageVisibility = () => {
      if (document.hidden) videos.forEach(video => video.pause());
      else updateMotion();
    };
    reducedMotion.addEventListener('change', updateMotion);
    connection?.addEventListener?.('change', updateMotion);
    document.addEventListener('visibilitychange', pageVisibility);
    updateMotion();
    root.nv9Cleanup = () => {
      mediaObserver?.disconnect();
      reducedMotion.removeEventListener('change', updateMotion);
      connection?.removeEventListener?.('change', updateMotion);
      document.removeEventListener('visibilitychange', pageVisibility);
      videos.forEach(video => video.pause());
    };
    const sticky = root.querySelector('.nv7-sticky');
    const primary = root.querySelector('.nv7-buybox .nv7-buy-button');
    if (sticky && primary && 'IntersectionObserver' in window) {
      const visibility = new Map();
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => visibility.set(entry.target, entry.isIntersecting));
        sticky.classList.toggle('is-hidden', [...visibility.values()].some(Boolean));
      }, { threshold: 0.1 });
      observer.observe(primary);
      if (stage) observer.observe(stage);
    }
    root.querySelectorAll('a[href^="#nv7-"]').forEach(anchor => {
      anchor.addEventListener('click', () => {
        const menu = root.querySelector('.nv18-menu');
        if (menu) menu.open = false;
      });
    });
  }
  document.querySelectorAll('[data-nv7]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-nv7]').forEach(init));
  document.addEventListener('shopify:section:unload', e => e.target.querySelectorAll('[data-nv7]').forEach(root => root.nv9Cleanup?.()));
})();
